module.exports = __webpack_public_path__ + "static/img/wlw.a41f71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wlw.png
// module id = 40uw
// module chunks = 0